import {mapGetters} from "vuex";
import Logout from "@/mixins/Logout";

export default {
    mixins: [Logout],
    computed: {
        ...mapGetters({
            companyInfoId: "getCompanyId",
            editCompanyInfoId: "getEditCompanyInfoId",
            isSiteAdminOrUser : "isSiteAdminOrUser",
            officesByCompanyInfo: "getOfficesByCompanyInfo",
            getEditOfficesByCompanyInfoId: "getEditOfficesByCompanyInfoId"
        }),
    },
    methods: {
        loadCompanyId(){
            return this.isSiteAdminOrUser ? this.companyInfoId : this.editCompanyInfoId
        },
        loadCompanyOffices(){
            return this.isSiteAdminOrUser ? this.officesByCompanyInfo : this.getEditOfficesByCompanyInfoId
        },
        isErrorText(data){
            return Boolean(data?.response?.data?.errorCode || data?.response?.status)
        },
        getErrorText(data) {
            if(!this.isErrorText(data)) {
                console.error('[APP][getErrorText] ERROR:', data)
                return ''
            }
            const errorCode = data?.response?.data?.errorCode || data?.response?.status
            this.errorForLogout(data?.response, data?.path)

            return errorCode
        },
        errorForLogout(errorCode, path) {
            if (errorCode?.status === 401) {
                setTimeout(() => {
                    this.logoutSession(path)
                }, 2000);
            }
        }
    }
};
